import { render, staticRenderFns } from "./FormGroupConfig.vue?vue&type=template&id=3d853383&scoped=true&"
import script from "./FormGroupConfig.vue?vue&type=script&lang=js&"
export * from "./FormGroupConfig.vue?vue&type=script&lang=js&"
import style0 from "./FormGroupConfig.vue?vue&type=style&index=0&id=3d853383&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d853383",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d853383')) {
      api.createRecord('3d853383', component.options)
    } else {
      api.reload('3d853383', component.options)
    }
    module.hot.accept("./FormGroupConfig.vue?vue&type=template&id=3d853383&scoped=true&", function () {
      api.rerender('3d853383', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/FormGroupConfig.vue"
export default component.exports